import Style from './style'

const ParticipationHistory = ({data}) => {
	// Transform the data to match the image format
	const transformData = (participationData) => {
		if (!participationData || participationData.length === 0) return []

		return participationData
			.slice()
			.reverse()
			.map((entry, index) => {
				const entryType =
					entry.re_entry_count === 0
						? '첫 참가'
						: `${entry.re_entry_count}${getOrdinalSuffix(
								entry.re_entry_count
						  )} 재입장`

				return {
					entryType,
					entryTime: new Date(entry.created_at).toLocaleString('en-US', {
						month: 'numeric',
						day: 'numeric',
						year: 'numeric',
						hour: 'numeric',
						minute: '2-digit',
						second: '2-digit',
						hour12: true,
					}),
					eliminateTime: new Date(entry.leaving_time).toLocaleString('en-US', {
						month: 'numeric',
						day: 'numeric',
						year: 'numeric',
						hour: 'numeric',
						minute: '2-digit',
						second: '2-digit',
						hour12: true,
					}),
				}
			})
	}

	const getOrdinalSuffix = (num) => {
		const j = num % 10
		const k = num % 100
		if (j === 1 && k !== 11) return 'st'
		if (j === 2 && k !== 12) return 'nd'
		if (j === 3 && k !== 13) return 'rd'
		return 'th'
	}

	const transformedData = transformData(data)

	return (
		<Style.Container>
			<Style.NameRow>
				<Style.SectionTitle>참가 기록</Style.SectionTitle>
			</Style.NameRow>

			<Style.ContentContainer>
				{data && data.length > 0 ? (
					<>
						{transformedData?.map((entry, index) => {
							return (
								<Style.EntryContainer key={index}>
									<Style.EntryRow>
										<Style.EntryType>{entry.entryType}</Style.EntryType>
										<Style.EntryTime>{entry.entryTime}</Style.EntryTime>
									</Style.EntryRow>
									<Style.EntryRow>
										<Style.EliminateLabel>제외 시간</Style.EliminateLabel>
										<Style.EliminateTime>
											{entry.eliminateTime}
										</Style.EliminateTime>
									</Style.EntryRow>
								</Style.EntryContainer>
							)
						})}
					</>
				) : (
					<Style.EmptyContainer>
						<Style.EmptyText>참가 기록이 없습니다</Style.EmptyText>
					</Style.EmptyContainer>
				)}
			</Style.ContentContainer>
		</Style.Container>
	)
}

export default ParticipationHistory
